/*
 * BikeHouse – bh-core.js
 * Correcciones críticas (borrador): accesibilidad del header, variantes,
 * cantidad, WhatsApp dinámico y búsqueda.
 * Sin dependencias (no requiere jQuery). Se carga con defer.
 * Reversión: quitar la etiqueta <script src="bh-core.js"> de layout/theme.liquid.
 */
(function () {
  'use strict';

  var BH = window.BH = window.BH || {};

  /* ------------------------------------------------------------------ */
  /* Utilidades                                                          */
  /* ------------------------------------------------------------------ */
  BH.formatCLP = function (cents) {
    var n = Math.round((Number(cents) || 0) / 100);
    return '$' + String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* Formato monetario chileno para scripts heredados del tema */
  function patchMoney() {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && !window.Shopify.__bhMoney) {
      var original = window.Shopify.formatMoney;
      window.Shopify.formatMoney = function (cents, format) {
        if (window.BH_CURRENCY === 'CLP') {
          if (typeof cents === 'string') cents = cents.replace(/[^\d]/g, '');
          return BH.formatCLP(cents);
        }
        return original.apply(this, arguments);
      };
      window.Shopify.__bhMoney = true;
    }
  }

  /* Normaliza precios que el tema o apps pintan con coma ($424,990 o $424,990.00 → $424.990).
     Respaldo mientras no se cambie el formato de moneda de la tienda en Configuración > General. */
  var PRICE_RE = /\$\s?(\d{1,3}(?:,\d{3})+)(?:\.\d{2})?(?!\d)/g;
  function normalizePrices(root) {
    if (window.BH_CURRENCY !== 'CLP' || !document.createTreeWalker) return;
    var w = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (!p || /^(SCRIPT|STYLE|TEXTAREA|NOSCRIPT)$/.test(p.nodeName)) return NodeFilter.FILTER_REJECT;
        return n.nodeValue.indexOf('$') > -1 && /\d,\d{3}/.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var nodes = [], n;
    while ((n = w.nextNode())) nodes.push(n);
    nodes.forEach(function (t) {
      t.nodeValue = t.nodeValue.replace(PRICE_RE, function (m, num) { return '$' + num.replace(/,/g, '.'); });
    });
  }
  function watchPrices() {
    normalizePrices();
    if (!window.MutationObserver) return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return; pending = true;
      setTimeout(function () { pending = false; normalizePrices(); }, 250);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  /* ------------------------------------------------------------------ */
  /* Header: botones accesibles (buscador, carrito, menú)                */
  /* ------------------------------------------------------------------ */
  function initHeaderA11y() {
    // Activación por teclado para disparadores que aún no son <button>
    qsa('[data-bh-kbd]').forEach(function (el) {
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          el.click();
        }
      });
    });

    // Sincroniza aria-expanded con la clase de estado que usa el tema
    function syncExpanded(btn, isOpen) {
      btn.setAttribute('aria-expanded', isOpen() ? 'true' : 'false');
    }

    var desktopSearch = qs('.button-header-search');
    if (desktopSearch) {
      desktopSearch.addEventListener('click', function () {
        setTimeout(function () {
          var form = qs('.header-center .search-header-inline');
          var open = !!(form && form.classList.contains('show'));
          desktopSearch.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (open) { var i = qs('input[name="q"]', form); if (i) i.focus(); }
        }, 30);
      });
    }

    var mobileSearch = qs('.mobile-btn_search');
    if (mobileSearch) {
      mobileSearch.addEventListener('click', function () {
        setTimeout(function () {
          var open = mobileSearch.classList.contains('act');
          mobileSearch.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (open) { var i = qs('#mobile_search input[name="q"]'); if (i) i.focus(); }
        }, 30);
      });
    }

    qsa('[data-bh-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTimeout(function () {
          syncExpanded(btn, function () { return btn.classList.contains('act'); });
        }, 30);
      });
    });

    qsa('.site-header__cart[aria-controls]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTimeout(function () {
          var panel = document.getElementById('desktop_cart');
          btn.setAttribute('aria-expanded', panel && panel.classList.contains('active') ? 'true' : 'false');
        }, 30);
      });
    });

    // Escape cierra paneles abiertos (buscador, carrito, menú móvil)
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var closed = false;
      qsa('.search-header-inline.show').forEach(function (f) { f.classList.remove('show'); closed = true; });
      qsa('.button-header-search.hide').forEach(function (b) { b.classList.remove('hide'); });
      var ms = qs('.mobile-btn_search.act');
      if (ms) { ms.click(); closed = true; }
      var cart = qs('#desktop_cart.active');
      if (cart) { var c = qs('.close_cart'); if (c) c.click(); else cart.classList.remove('active'); closed = true; }
      var menu = qs('#mobile_menu.act, .site-nav--btn.act, #show-megamenu.act');
      if (menu) { var ov = qs('.sidebar-overlay'); if (ov) ov.click(); closed = true; }
      if (closed) {
        qsa('[aria-expanded="true"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        var back = qs('.button-header-search') || qs('.mobile-btn_search');
        if (back && document.activeElement && document.activeElement.closest && document.activeElement.closest('.search-header-inline, #desktop_cart, #mobile_menu')) back.focus();
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* Producto: variantes, cantidad y WhatsApp                            */
  /* ------------------------------------------------------------------ */
  function ProductController(root) {
    this.root = root;
    var dataEl = qs('script[data-bh-product-json]', root);
    if (!dataEl) return;
    try { this.data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    this.form = qs('form.product-form', root) || qs('form[action*="/cart/add"]', root);
    this.idInput = this.form ? qs('input[name="id"]', this.form) : null;
    this.qtyInput = qs('[data-bh-qty-input]', root);
    this.addBtn = qs('[data-bh-add]', root);
    this.waPrimary = qsa('[data-bh-wa-primary]', root);
    this.waSize = qsa('[data-bh-wa-size]', document);
    this.variant = this.findById(this.idInput ? parseInt(this.idInput.value, 10) : null) || this.data.variants[0];
    this.bind();
    this.render(false);
  }

  ProductController.prototype.findById = function (id) {
    if (!id) return null;
    for (var i = 0; i < this.data.variants.length; i++) if (this.data.variants[i].id === id) return this.data.variants[i];
    return null;
  };

  ProductController.prototype.readOptions = function () {
    var root = this.root, values = [];
    var fieldsets = qsa('product-variant-swatch fieldset', root);
    if (fieldsets.length) {
      fieldsets.forEach(function (fs) {
        var c = qs('input:checked', fs);
        values.push(c ? c.value : null);
      });
      return values;
    }
    var selects = qsa('product-variant-dropdown select', root);
    if (selects.length) return selects.map(function (s) { return s.value; });
    return null;
  };

  ProductController.prototype.findByOptions = function (values) {
    if (!values) return null;
    for (var i = 0; i < this.data.variants.length; i++) {
      var v = this.data.variants[i], ok = true;
      for (var j = 0; j < values.length; j++) { if (v.options[j] !== values[j]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  };

  ProductController.prototype.bind = function () {
    var self = this;
    var pickers = qsa('product-variant-swatch, product-variant-dropdown', this.root);
    pickers.forEach(function (p) {
      p.addEventListener('change', function () {
        var v = self.findByOptions(self.readOptions());
        self.variant = v || null;
        self.render(true);
      });
    });

    // Cantidad: un solo manejador por botón (evita dobles incrementos)
    qsa('[data-bh-qty]', this.root).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        self.stepQty(btn.getAttribute('data-bh-qty') === 'plus' ? 1 : -1);
      });
    });
    if (this.qtyInput) {
      this.qtyInput.addEventListener('change', function () { self.clampQty(); self.updateWhatsApp(); });
      this.qtyInput.addEventListener('input', function () { self.updateWhatsApp(); });
    }

    // Refresca el enlace justo antes de usarlo (por si otro script cambió algo)
    this.waPrimary.concat(this.waSize).forEach(function (a) {
      ['mousedown', 'keydown', 'touchstart'].forEach(function (ev) {
        a.addEventListener(ev, function () { self.updateWhatsApp(); }, { passive: true });
      });
    });

    window.addEventListener('popstate', function () {
      var m = location.search.match(/[?&]variant=(\d+)/);
      var v = m ? self.findById(parseInt(m[1], 10)) : self.data.variants[0];
      if (v) { self.variant = v; self.syncInputs(); self.render(false); }
    });
  };

  ProductController.prototype.maxQty = function () {
    var v = this.variant;
    if (!v) return 1;
    if (v.tracked && v.policy === 'deny' && v.inventory > 0) return v.inventory;
    return 99;
  };

  ProductController.prototype.clampQty = function () {
    if (!this.qtyInput) return 1;
    var q = parseInt(this.qtyInput.value, 10);
    if (isNaN(q) || q < 1) q = 1;
    var max = this.maxQty();
    if (q > max) q = max;
    this.qtyInput.value = q;
    this.qtyInput.setAttribute('max', max);
    this.updateQtyButtons();
    return q;
  };

  ProductController.prototype.stepQty = function (d) {
    if (!this.qtyInput) return;
    var q = (parseInt(this.qtyInput.value, 10) || 1) + d;
    this.qtyInput.value = q;
    this.clampQty();
    this.updateWhatsApp();
  };

  ProductController.prototype.updateQtyButtons = function () {
    if (!this.qtyInput) return;
    var q = parseInt(this.qtyInput.value, 10) || 1, max = this.maxQty();
    qsa('[data-bh-qty="minus"]', this.root).forEach(function (b) { b.disabled = q <= 1; });
    qsa('[data-bh-qty="plus"]', this.root).forEach(function (b) { b.disabled = q >= max; });
  };

  // Ajusta radios/selects para que coincidan con la variante (p. ej. al usar "atrás")
  ProductController.prototype.syncInputs = function () {
    var v = this.variant;
    if (!v) return;
    qsa('product-variant-swatch fieldset', this.root).forEach(function (fs, i) {
      qsa('input[type="radio"]', fs).forEach(function (r) { r.checked = (r.value === v.options[i]); });
    });
    qsa('product-variant-dropdown select', this.root).forEach(function (s, i) { s.value = v.options[i]; });
  };

  ProductController.prototype.qty = function () {
    return this.qtyInput ? (parseInt(this.qtyInput.value, 10) || 1) : 1;
  };

  ProductController.prototype.variantUrl = function () {
    var base = this.data.url;
    if (this.variant && !this.data.onlyDefault) base += '?variant=' + this.variant.id;
    return base;
  };

  ProductController.prototype.message = function (kind) {
    var d = this.data, v = this.variant;
    var parts = [];
    if (v && !d.onlyDefault) {
      d.options.forEach(function (name, i) {
        if (v.options[i] != null) parts.push(d.optionLabels[i] + ' ' + v.options[i]);
      });
    }
    var txt;
    if (kind === 'size') {
      txt = 'Hola BikeHouse. Necesito ayuda para elegir la talla de ' + d.title + '.';
      if (parts.length) txt += ' Estoy mirando: ' + parts.join(', ') + '.';
      txt += ' Mi estatura es: ___ y la usaré para: ___. Enlace: ' + this.variantUrl();
      return txt;
    }
    txt = 'Hola BikeHouse. Quiero consultar por ' + d.title;
    if (parts.length) txt += ', ' + parts.join(', ');
    txt += ', cantidad ' + this.qty();
    if (v) txt += ', precio publicado ' + BH.formatCLP(v.price);
    txt += '.';
    if (v && !v.available) txt += ' ¿Está disponible y cuál es el plazo de entrega?';
    txt += ' Enlace: ' + this.variantUrl();
    return txt;
  };

  ProductController.prototype.waHref = function (kind) {
    return 'https://wa.me/' + this.data.phone + '?text=' + encodeURIComponent(this.message(kind));
  };

  ProductController.prototype.updateWhatsApp = function () {
    var self = this;
    this.waPrimary.forEach(function (a) { a.href = self.waHref('consulta'); });
    this.waSize.forEach(function (a) { a.href = self.waHref('size'); });
  };

  ProductController.prototype.render = function (pushUrl) {
    var v = this.variant, d = this.data, root = this.root;
    // Se buscan en cada render: el script del tema reemplaza el bloque de precio por HTML nuevo
    this.priceEl = qs('[data-bh-price]', root);
    this.compareEl = qs('[data-bh-compare]', root);
    this.badgeEl = qs('[data-bh-discount]', root);
    this.availEl = qs('[data-bh-availability]', root);
    this.selectedLabel = qsa('[data-bh-option-label]', root);

    // Combinación inexistente
    if (!v) {
      if (this.availEl) { this.availEl.textContent = 'Esta combinación no existe. Elige otra talla o color.'; this.availEl.setAttribute('data-state', 'none'); }
      if (this.addBtn) { this.addBtn.disabled = true; this.setAddText('No disponible'); }
      this.waPrimary.forEach(function (a) { a.setAttribute('aria-disabled', 'true'); });
      return;
    }
    this.waPrimary.forEach(function (a) { a.removeAttribute('aria-disabled'); });

    // ID de variante en el formulario
    if (this.idInput && String(this.idInput.value) !== String(v.id)) this.idInput.value = v.id;

    // Precio y precio comparativo
    if (this.priceEl) this.priceEl.textContent = BH.formatCLP(v.price);
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    if (this.compareEl) { this.compareEl.textContent = onSale ? BH.formatCLP(v.compare_at_price) : ''; this.compareEl.hidden = !onSale; }
    if (this.badgeEl) {
      this.badgeEl.hidden = !onSale;
      if (onSale) this.badgeEl.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
    }

    // Disponibilidad (sin prometer stock en venta asistida)
    if (this.availEl) {
      var t;
      if (!v.available) t = !d.showSoldOut ? 'Consulta disponibilidad y plazo de entrega por WhatsApp' : (d.assisted ? 'Agotado en línea · consúltanos por reposición o alternativas' : 'Agotado');
      else if (d.assisted) t = 'Disponible · confirmamos stock y talla por WhatsApp antes de tu compra';
      else if (v.tracked && v.inventory > 0 && v.inventory <= 3) t = 'Disponible · últimas ' + v.inventory + ' unidades';
      else t = 'Disponible';
      this.availEl.textContent = t;
      this.availEl.setAttribute('data-state', v.available ? 'in' : 'out');
    }

    // Botón principal
    if (this.addBtn) {
      this.addBtn.disabled = !v.available;
      this.setAddText(v.available ? 'Agregar al carrito' : (d.showSoldOut ? 'Agotado' : 'No disponible en línea'));
    }

    // Opción seleccionada visible en cada leyenda
    this.selectedLabel.forEach(function (el) {
      var i = parseInt(el.getAttribute('data-bh-option-label'), 10);
      el.textContent = v.options[i] || '';
    });
    qsa('product-variant-swatch fieldset', this.root).forEach(function (fs, i) {
      qsa('label', fs).forEach(function (l) {
        var input = document.getElementById(l.getAttribute('for'));
        var on = !!(input && input.value === v.options[i]);
        l.classList.toggle('bh-selected', on);
        l.setAttribute('aria-current', on ? 'true' : 'false');
      });
    });

    // Imagen asociada a la variante
    if (pushUrl && v.media_id) {
      var thumb = qs('[data-media-id$="-' + v.media_id + '"] a, [data-media-id$="-' + v.media_id + '"]', this.root);
      if (thumb && thumb.click) { try { thumb.click(); } catch (e) {} }
    }

    // Cantidad dentro de los límites
    this.clampQty();

    // URL con la variante (sin recargar)
    if (pushUrl && !d.onlyDefault && window.history && history.replaceState) {
      var url = location.pathname + '?variant=' + v.id;
      try { if (location.pathname + location.search !== url) history.replaceState({ variant: v.id }, '', url); } catch (e) {}
    }

    this.updateWhatsApp();
  };

  ProductController.prototype.setAddText = function (t) {
    if (!this.addBtn) return;
    var span = qs('[data-bh-add-text]', this.addBtn) || this.addBtn;
    span.textContent = t;
  };

  function initProducts() {
    qsa('[data-bh-product]').forEach(function (root) {
      if (!root.__bh) root.__bh = new ProductController(root);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Búsqueda                                                            */
  /* ------------------------------------------------------------------ */
  function initSearch() {
    // Todas las búsquedas usan la URL nativa indexable /search?q=...&type=product
    qsa('form[action="/search"], form[action$="/search"]').forEach(function (f) {
      f.addEventListener('submit', function (e) {
        var i = qs('input[name="q"]', f);
        if (i && !i.value.trim()) { e.preventDefault(); i.focus(); }
      });
    });
    // Mantiene la consulta escrita en todos los campos al volver con "atrás"
    var m = location.pathname.indexOf('/search') === 0 ? new URLSearchParams(location.search).get('q') : null;
    if (m) qsa('input[name="q"]').forEach(function (i) { if (!i.value) i.value = m; });
  }

  /* ------------------------------------------------------------------ */
  function init() {
    patchMoney();
    initHeaderA11y();
    initProducts();
    initSearch();
    watchPrices();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', patchMoney);
})();